import { SVG_ICONS } from '@utils/SvgIcons';
import { Text } from 'native-base';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Animated, Pressable, View } from 'react-native';
import styles from './style';

const ReferralButton = ({ onRefferalCta }) => {
  const { t } = useTranslation('common');
  const animation = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.spring(animation, {
          toValue: 1,
          duration: 10,
          speed: 10,
          bounciness: 15,
          useNativeDriver: true,
        }),
        Animated.spring(animation, {
          toValue: 0,
          duration: 10,
          bounciness: 15,
          useNativeDriver: true,
          speed: 10,
        }),
      ]),
    ).start();
  }, []);

  const interpolated = animation.interpolate({
    inputRange: [0, 0.5, 1],
    outputRange: ['-30deg', '0deg', '30deg'],
  });

  return (
    <View testID="referral-container" sentry-label="referral-container" style={styles.pressableContainer}>
      <Pressable testID="referral-button" style={styles.referralPressable} onPress={onRefferalCta}>
        <View style={styles.iconView}>
          <Animated.View style={styles.animatedButtonStyle(interpolated)}>{SVG_ICONS.giftNew}</Animated.View>
        </View>
        <Text testID="txtReferralInvite" variant="sm-bold" style={styles.textStyle}>
          {t('referral.invite')}
        </Text>
      </Pressable>
    </View>
  );
};

ReferralButton.propTypes = {
  onRefferalCta: PropTypes.func,
};

ReferralButton.defaultProps = {
  onRefferalCta: () => {},
};

export default ReferralButton;
